/** @file NodeBadges: the small badges of a tree row (key, IK, mirror, socket, hidden-in-data, flex parent). */
import type { CSSProperties, ReactElement } from 'react';
import type { TreeRow } from './treeRows';

const badge: CSSProperties = { fontSize: 10, padding: '0 3px', borderRadius: 3, border: '1px solid var(--border, #2a2e38)', color: 'var(--info, #7fd1ff)' };

/** Badges for `row`; `keyed` says the node has a key at the playhead frame (`frame`). */
export function NodeBadges({ row, keyed, frame }: { row: TreeRow; keyed: boolean; frame: number }): ReactElement {
  return (
    <>
      {keyed && <span title={`key at frame ${frame}`} style={{ ...badge, color: 'var(--accent, #f2b544)' }}>◆</span>}
      {row.ik > 0 && <span title={`IK chain of ${row.ik}`} style={badge}>IK{row.ik}</span>}
      {row.mirror !== null && <span title={`mirror twin: ${row.mirror}`} style={badge}>⇄</span>}
      {row.sockets.length > 0 && <span title={`socket ${row.sockets.join(', ')}`} style={badge}>◎</span>}
      {row.flexParent && <span title="flexible parent (clips may re-parent it)" style={badge}>flex</span>}
      {(row.hidden || row.hiddenAbove) && (
        <span title={row.hidden ? 'hidden in data (node.hidden)' : 'a parent is hidden in data'} style={{ ...badge, opacity: row.hidden ? 0.8 : 0.35 }}>⊘</span>
      )}
    </>
  );
}
